import React from 'react';
import ReactPlayer from 'react-player';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { withStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { addVideoLog } from '../../redux/actions/adminActions';
import { FlagRounded, MoreHorizRounded } from '@material-ui/icons';
import CenterLoading from '../layout/CenterLoading';

// reactPlayer에서 권고하는 세팅
const styles = (theme) => ({
    ...theme.userPage,
    playerWrapper: {
        position: 'relative',
        paddingTop: '56.25%',
    },
    reactPlayer: {
        position: 'absolute',
        top: 0,
        left: 0,
    },
    noVideo: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
    },
    border: {
        border: '1px solid #444',
        backgroundColor: '#111',
        borderRadius: 8,
    }
});

export const VideoClipWithLog = (props) => {
    const { classes, url, category, videoName, runningTime, typeId, afterSchool, videoUserLogs } = props;
    const dispatch = useDispatch();

    const handleStart = () => {
        const args = {
            afterschoolId: afterSchool?.id,
            typeId: typeId,
            url: url,
        };
        dispatch(addVideoLog({ ...args, status: 'ing' }));
    };
    const handleEnd = async () => {
        const args = {
            afterschoolId: afterSchool?.id,
            typeId: typeId,
            url: url,
        };
        dispatch(addVideoLog({ ...args, status: 'done' }));
    };

    if (videoUserLogs) {
        const log = videoUserLogs?.find((vl) => vl.url === url) || null;

        return (
            <Box p={1} m={1}>
                <Box className={clsx(classes.playerWrapper, { [classes.border]: !url})}>
                    {url ? (
                        <ReactPlayer
                            className={classes.reactPlayer}
                            url={url}
                            width="100%"
                            height="100%"
                            pip={true}
                            controls={true}
                            allow="fullScreen"
                            onEnded={handleEnd}
                            onStart={handleStart}
                        />
                    ) : (
                       <Box className={classes.noVideo}><Typography>영상 준비중입니다</Typography></Box>
                    )}
                </Box>
                {videoName === '' || typeof videoName === 'undefined' ? null : (
                    <Box p={1} m={1} position="relative">
                        <Typography variant="body2">{category}</Typography>
                        <Typography variant="subtitle2">{videoName}</Typography>
                        <Typography variant="caption">{runningTime}</Typography>
                        <Box display="flex" alignItems="center" style={{ position: 'absolute', top: 5, right: 3 }}>
                            {log?.status === 'done' && <FlagRounded color="secondary" style={{ fontSize: 18 }} />}
                            {log?.status === 'ing' && <MoreHorizRounded color="primary" style={{ fontSize: 18 }} />}
                            <Typography
                                variant="caption"
                                color={log?.status === 'ing' ? 'primary' : 'secondary'}
                                style={{ fontSize: 12, fontWeight: '500' }}
                            >
                                {log?.status === 'done'
                                    ? '수강완료 (' + dayjs(log?.createdAt * 1000).format('YYYY-MM-DD') + ')'
                                    : log?.status === 'ing'
                                    ? '수강중'
                                    : ''}
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        );
    } else {
        return <CenterLoading />;
    }
};

export default withStyles(styles)(VideoClipWithLog);
